import styled, { css } from 'styled-components'
import { Colors, ColorUtils } from 'src/resources/colors'
import { Spacing } from 'src/resources/layout'
import { PrettyCount } from 'src/applications/Oversight/components/PrettyCount'
import { themed } from 'src/applications/Embed/fragments/ThemeWrapper'
import { inputStyles } from 'src/resources/inputs'

const Count = styled.div<{ active?: boolean; disabled?: boolean; rejected?: boolean }>`
  padding: ${Spacing.quarterBasePadding} ${Spacing.basePadding};
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: ${({ disabled }) => (disabled ? Colors.pigeon600 : 'inherit')};
  background: ${({ theme, active, disabled, rejected }) =>
    active && !rejected
      ? ColorUtils.rgbaToRgb(ColorUtils.hexToRgba(theme.primary, 0.7))
      : disabled
      ? Colors.pigeon200
      : rejected && active
      ? Colors.pinata600
      : ColorUtils.rgbaToRgb(ColorUtils.hexToRgba(theme.primary, 0.7))};
  margin-left: ${Spacing.basePadding};
  border-radius: ${themed('dropdownBorderRadius') ?? themed('borderRadius')};
  ${({ theme }) =>
    theme?.flexport &&
    css`
      background-color: transparent;
      padding-left: 0;
      padding-right: 0;
      &:before {
        content: '( ';
      }
      &:after {
        content: ' )';
      }
    `}
`

const TabContainer = styled.div<{ active?: boolean; disabled?: boolean; rejected?: boolean }>`
  border-radius: ${themed('finalFilterBorderRadius') ?? themed('borderRadius')};
  font-size: ${themed('buttonSize')};
  font-weight: ${inputStyles.fontWeight};
  color: ${({ active, disabled }) =>
    active ? Colors.white : disabled ? Colors.pigeon600 : Colors.textLogo};
  background: ${({ active, rejected, theme }) =>
    active && rejected
      ? Colors.pinata800
      : active
      ? theme.secondary
        ? theme.secondary
        : theme.primary
        ? theme.primary
        : Colors.brandPrimary
      : 'transparent'};
  ${({ disabled }) => !disabled && `cursor: pointer`};

  padding: 7px ${Spacing.baseAndHalfPadding};
  height: ${themed('buttonHeight')};
  letter-spacing: ${themed('buttonLetterSpacing')};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s;

  ${({ active, theme }) =>
    active &&
    !theme.flexport &&
    css`
      ${Count} {
        background: ${(props) => {
          const rgba = ColorUtils.hexToRgba(
            props.theme.secondary ?? props.theme.primary ?? Colors.brandPrimary,
            0.8
          )
          return ColorUtils.rgbaToRgb(rgba)
        }};
        color: inherit;
      }
    `}
`
interface IStatus {
  label: string
  value?: string
}
interface IStatusTab {
  status: IStatus
  active?: boolean
  count: number
  onClick?: () => void
  rejected?: boolean
}

export function StatusTab({ status, count, active, onClick, rejected }: IStatusTab) {
  const disabled = count === 0
  return (
    <TabContainer
      active={active}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      rejected={rejected}
    >
      <div>{status.label}</div>
      <Count active={active} disabled={disabled} rejected={rejected}>
        <PrettyCount count={count} suffix='records' />
      </Count>
    </TabContainer>
  )
}
